import styled from 'styled-components';

export const FormInsideWrap = styled.div`
  padding-right: 50px;
  & .ant-input {
    padding: 4px 11px;
  }
  .ant-select-selector {
    height: 34px !important;
  }
  .ant-select-selection-item {
    line-height: 34px !important;
    font-size: 14px !important;
  }
  .ant-input-affix-wrapper-lg {
    padding: 4px 11px !important;
  }
`;
export const GmailAuthAbout = styled.div`
  font-weight: normal;
  font-size: 14px;
  width: 100%;
  text-align: end;
  margin-bottom: 24px;
`;
export const TestMailWraper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 800px;
  @media screen and (max-width: 750px) {
    flex-direction: column;
  }
`;
